import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OutsideClickService {
  private readonly cleanupByBindId = new Map<string, () => void>();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private ngZone: NgZone,
  ) {}

  bind(bindId: string, elementsWhitelist: string, callback: () => void): void {
    this.unbind(bindId);

    const handler = (event: Event) => {
      const elements = this.document.querySelectorAll(elementsWhitelist);

      for (let i = 0; i < elements.length; i++) {
        if (elements[i].contains(event.target as Node)) {
          return;
        }
      }

      this.ngZone.run(() => {
        setTimeout(() => callback());
      });
    };

    this.document.addEventListener('click', handler);
    this.document.addEventListener('touchstart', handler);

    this.cleanupByBindId.set(bindId, () => {
      this.document.removeEventListener('click', handler);
      this.document.removeEventListener('touchstart', handler);
    });
  }

  unbind(bindId: string): void {
    const cleanup = this.cleanupByBindId.get(bindId);

    if (cleanup) {
      cleanup();
      this.cleanupByBindId.delete(bindId);
    }
  }
}
